<template>
  <component
    :is="cardComponent"
    v-if="cardComponent"
    :interaction="interaction"
    :live="live"
    @submit="$emit('submit', $event)"
  />
</template>

<script>
import ChoicePromptCard from "./ChoicePromptCard.vue";
import QuizCard from "./QuizCard.vue";

// Typed dispatch: unknown interaction types render nothing so older app
// versions degrade gracefully to the text message.
const CARD_COMPONENTS = {
  choicePrompt: ChoicePromptCard,
  quiz: QuizCard,
};

export default {
  name: "InteractionRenderer",
  props: {
    interaction: { type: Object, required: true },
    live: { type: Boolean, default: false },
  },
  emits: ["submit"],
  computed: {
    cardComponent() {
      return CARD_COMPONENTS[this.interaction?.type] || null;
    },
  },
};
</script>
